@if (currentTenantId()) {
  <div class="cooperative-dashboard">
    @if (isInternalTenant()) {
      <div class="tenant-filter">
        <div class="filter-control-group">
          <label class="label" for="tenant">Kunde</label>
          <wr-tenant-select id="tenant"
                            [tenantType]="TenantDetailDto.TypeEnum.External"
                            [showEmptyOption]="true"
                            [ngModel]="selectedTenantId()"
                            (ngModelChange)="selectedTenantId.set($event)">
          </wr-tenant-select>
        </div>
      </div>
    }
    <wr-tenant-dashboard-inspection-overview [tenantId]="tenantId"></wr-tenant-dashboard-inspection-overview>
    <wr-tenant-dashboard-building-overview [tenantId]="tenantId"></wr-tenant-dashboard-building-overview>
    @if (repairTasksVisible()) {
      <wr-tenant-dashboard-repair-task-overview [tenantId]="tenantId"></wr-tenant-dashboard-repair-task-overview>
    }
  </div>
}
